<template>
	<div class="public-content order">
		<div class="breadcrumb">{{ formInline.originType == 'BRIDAL' ? '婚纱订单查询' : formInline.originType == 'VIDEO' ? '影像季本店订单' : '订单查询' }}</div>
		<div class="right-main">
			<!--      查询订单-->
			<el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
				<el-row>
					<el-col v-permission="'oms:admin:order:one'" :span="6">
						<el-form-item label="订单号:">
							<el-input v-model="formInline.orderNo" placeholder="请输入订单号" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="用户名:">
							<el-select clearable v-model="formInline.userId" :filter-method="selectUserList" filterable placeholder="请输入用户名">
								<el-option v-for="item in userList" :key="item.id" :label="item.userName" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="平台号:">
							<el-select clearable v-model="formInline.storeCode" :filter-method="filterMethod" filterable placeholder="请输入平台号">
								<el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.code"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="平台名称:">
							<el-select clearable v-model="formInline.storeId" :filter-method="filterByName" filterable placeholder="请输入平台名称">
								<el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="平台类型:">
							<el-select v-model="formInline.storeType" placeholder="请选择" clearable>
								<el-option label="" value="">全部</el-option>
								<el-option v-for="item in basicsInfo.storeTypeList" :key="item.id" :label="item.name" :value="item.code"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="支付状态:">
							<el-select v-model="formInline.paymentStatus" placeholder="请选择" clearable>
								<el-option label="" value="">全部</el-option>
								<el-option label="已支付" value="PAID"></el-option>
								<el-option label="未支付" value="UNPAID"></el-option>
								<!-- <el-option label="支付失败" value="FAILED"></el-option> -->
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="支付方式:">
							<!-- <el-select v-model="formInline.paymentType" placeholder="请选择" clearable>
								<el-option label="" value="">全部</el-option>
								<el-option label="微信" value="WXPAY"></el-option>
								<el-option label="支付宝" value="ALIPAY"></el-option>
								<el-option label="余额" value="VPAY"></el-option>
							</el-select> -->
							<el-select v-model="formInline.paymentType" clearable placeholder="请选择">
								<el-option v-for="(v, k) in $config.paymentTypeB" :key="k" :label="v" :value="k" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="订单状态:">
							<el-select v-model="formInline.orderStatus" placeholder="请选择" clearable>
								<el-option label="" value="">全部</el-option>
								<el-option v-for="(v, k) in $config.orderStatus" :key="k" :label="v" :value="k"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="业务:">
							<el-select clearable v-model="formInline.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
								<el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="开票状态:">
							<el-select clearable v-model="formInline.invoice" placeholder="请选择">
								<el-option label="已开票" :value="true" />
								<el-option label="未开票" :value="false" />
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="创建日期:" class="el-date-width">
							<el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="true" align="left" unlink-panels range-separator="至"
								start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :picker-options="pickerOptions"></el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<div class="fn-right form-btn">
					<el-button @click="(queryInfo.pageNum = 1), onSubmit()" round>查询</el-button>
					<el-button @click="exportExcel" round v-if="$hasPermission('oms:admin:order:export')">导出Excel</el-button>
				</div>
			</el-form>
			<div class="data-list">
				<el-table :data="tableData" border :row-class-name="rowClassName" style="width: 100%" :empty-text="!empty ? '正在获取数据中，请稍后...' : '暂无数据'">
					<el-table-column label="订单号" fixed="left" min-width="210px">
						<template v-slot="scope">
							<span v-if="$hasPermission('oms:admin:order:one')" @click="orderInfo(scope.row)" class="color-blue">{{ scope.row.orderNo }}</span>
							<span v-else>{{ scope.row.orderNo }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="phone" label="用户名" min-width="150px"></el-table-column>
					<el-table-column prop="storeCode" label="平台号" min-width="130px"></el-table-column>
					<el-table-column prop="storeName" label="平台名称" min-width="130px"></el-table-column>
					<el-table-column prop="storeType" label="平台类型">
						<template slot-scope="scope">
							<!-- <span> {{ scope.row.storeType === 'WXBIZ' ? '微商' : scope.row.storeType === 'STUDIO' ? '影楼' : scope.row.storeType === 'FULFILLER' ? '后期' : '' }} </span> -->
							<span> {{ storeType[scope.row.storeType] }} </span>
						</template>
					</el-table-column>
					<el-table-column prop="salesman" label="业务" min-width="130px"></el-table-column>
					<el-table-column prop="dateSubmitted" label="创建日期" min-width="170px"></el-table-column>
					<!-- v-permission="['check:money']" v-if="userType !== 'STORE_SUBADMIN'" -->
					<el-table-column prop="onlinePriceTotal" label="总价"></el-table-column>
					<el-table-column prop="priceTotal" label="会员总价">
						<template v-slot="scope">
							<span>{{ (scope.row.priceTotal - scope.row.discountAmountTotal + scope.row.fee).toFixed(2) }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="startupsPriceTotal" label="初创平台价格"></el-table-column>
					<el-table-column prop="priceReal" label="实付总价" min-width="80px">
						<template slot-scope="scope"> {{ scope.row.paymentStatus === 'UNPAID' ? '0' : scope.row.priceReal }} </template>
					</el-table-column>
					<el-table-column label="支付状态" min-width="80px">
						<template slot-scope="scope"> {{ scope.row.paymentStatus === 'UNPAID' ? '未支付' : '已支付' }} </template>
					</el-table-column>
					<el-table-column prop="datePayment" label="支付日期" min-width="170px"></el-table-column>
					<el-table-column prop="paymentType" label="支付方式" min-width="130px">
						<template slot-scope="scope">
							<span>{{ $config.paymentTypeB[scope.row.paymentType] }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="orderStatus" label="订单状态" fixed="right">
						<template slot-scope="scope">
							<div class="color-blue" @click="getOrderStatus(scope.row.orderNo)">{{ $config.orderStatus[scope.row.orderStatus] }}</div>
							<div class="color-blue" v-if="scope.row.invoice" @click="invoicePage(scope.row.orderNo)">已开票</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" fixed="right" min-width="100px">
						<template slot-scope="scope">
							<span :class="{ 'color-blue': scope.row.urgentStatus == 0 }"
								v-if="(formInline.originType == 'BRIDAL' ? $hasPermission('oms:admin:orderHs:urgent') : $hasPermission('oms:admin:order:urgent')) && (scope.row.orderStatus == 'CONFIRMED' || scope.row.orderStatus == 'PROCESSING' || scope.row.orderStatus == 'RENDER_DONE' || scope.row.orderStatus == 'DONE_DOWNLOAD')"
								@click="scope.row.urgentStatus == 0 ? urgent(scope.row) : ''">{{ scope.row.urgentStatus == 0 ? '加急' : scope.row.urgentStatus == 1 ? '已加急' : '' }}</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!--    分页-->
			<v-pagination class="v-pagination" @changePage="changePage" :queryInfo="queryInfo"></v-pagination>
		</div>
		<order-dialog ref="orderDialogRef"></order-dialog>
	</div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { getByOmsOrderNo } from '@/api/finance'
import OrderDialog from '@/components/Dialog/OrderDialog/OrderStatusDialog/index.vue'
import { order, orderPaymentTypeStatistic, orderLogList, orderExport, getUrgentOrderNo } from '@/api/oms'
import { storeTypeGetStoreTypeList, storeQueryListByCode, getSalesmanByFullName, storeQueryListByName, getAllUsersByUserName } from '@/api/crm'
export default {
	name: 'order',
	components: {
		VPagination,
		OrderDialog
	},
	watch: {
		value2: {
			handler (val, oldVal) {
				console.log(val)
				if (val) {
					this.formInline.dateStart = val[0] + ' 00:00:00'
					this.formInline.dateEnd = val[1] + ' 23:59:59'
				} else {
					this.formInline.dateStart = ''
					this.formInline.dateEnd = ''
				}
			},
			deep: true,
			immediate: true
		},
		$route: {
			handler: function (newRoute, oldRoute) {
				console.log('当前路由：', newRoute)
				console.log('之前的路由：', oldRoute)
				if (newRoute.path == '/orderHs') {
					this.formInline.originType = 'BRIDAL'
				} else if (newRoute.path == '/orderYxj') {
					this.formInline.originType = 'VIDEO'
				} else {
					this.formInline.originType = ''
				}
				if (oldRoute && (oldRoute.path == '/orderHs' || oldRoute.path == '/orderYxj' || oldRoute.path == '/order')) {
					this.onSubmit(this.queryInfo)
				}
				this.userList = []
			},
			// 深度观察监听
			deep: true,
			immediate: true
		}
	},
	data () {
		return {
			empty: false,
			userList: [],
			salemanList: [],
			storeListByCode: [],
			queryInfo: {
				total: 0,
				pageNum: 1, // 当前显示第几页
				pageSize: 10 // 每一页显示条数
			},
			formInline: {
				originType: '',
				channel: 'B2B',
				orderNo: '', // 订单号
				userName: '', // 用户名
				storeId: null,
				storeCode: '',
				storeName: '',
				agentName: '',
				orderType: null, // 订单类型
				paymentStatus: null, // 支付状态
				paymentType: null, // 支付方式
				orderStatus: null, // 订单状态
				dateStart: null,
				dateEnd: null,
				salesmanId: null,
				invoice: null
			},
			tableData: [],
			basicsInfo: {
				storeId: '',
				storeCode: '',
				storeName: '',
				fullName: '',
				storeTypeList: []
			},
			storeType: [], // 平台类型
			value2:
				this.$route.query.paymentStatus === 'UNPAID'
					? ''
					: [
						this.$moment()
							.subtract(6, 'months')
							.format('YYYY-MM-DD'),
						this.$moment().format('YYYY-MM-DD')
					],
			pickerOptions: {
				disabledDate (time) {
					return time.getTime() > Date.now() - 8.64e6
				},
				shortcuts: [
					{
						text: '最近一周',
						onClick (picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一个月',
						onClick (picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近三个月',
						onClick (picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
							picker.$emit('pick', [start, end])
						}
					}
				]
			}
		}
	},
	created () {
		if (sessionStorage.getItem('searchFlag') === 'true') {
			this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
			this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
			this.storeListByCode = JSON.parse(sessionStorage.getItem('storeListByCode'))
			this.userList = JSON.parse(sessionStorage.getItem('userList'))
			this.value2[0] = this.formInline.dateStart.split(' ')[0]
			this.value2[1] = this.formInline.dateEnd.split(' ')[0]
			sessionStorage.removeItem('searchFlag')
		} else {
			// 首次进入列表页,清除缓存中的搜索条件
			sessionStorage.removeItem('queryParams')
			sessionStorage.removeItem('queryInfo')
			sessionStorage.removeItem('storeListByCode')
			sessionStorage.removeItem('userList')
		}
		if (this.$route.query.paymentStatus === 'UNPAID') {
			this.formInline.paymentStatus = 'UNPAID'
			this.formInline.orderStatus = 'SUBMITTED'
			// this.value2 = []
		}
		this.onSubmit(this.queryInfo)
		this.getBasicsInfo()
	},
	destroyed () {
		// 销毁
		console.log('页面销毁')
		sessionStorage.removeItem('searchFlag')
	},
	methods: {
		// 加急
		urgent (row) {
			getUrgentOrderNo(row.orderId).then(res => {
				console.log('resssss', res)
				if (res.data.success) {
					this.$message.success('加急成功')
					this.onSubmit()
				}
			})
		},
		orderInfo (row) {
			sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
			sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
			sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
			sessionStorage.setItem('userList', JSON.stringify(this.userList))
			this.$router.push({ path: '/orderdetail', query: { orderNo: row.orderNo, way: 1 } })
		},
		// 查看发票
		invoicePage (val) {
			console.log('vaaaaalll', val)
			getByOmsOrderNo(val).then(res => {
				console.log(res)
				let receipt = res?.data?.data?.receipt
				if (receipt) {
					window.open(receipt.url ? receipt.url : '')
				}
			})
		},
		getBasicsInfo () {
			storeTypeGetStoreTypeList().then(res => {
				this.basicsInfo.storeTypeList = res.data.data
				this.storeType = []
				let storeTypeData = res.data.data
				const montage = (storeTypeData) => {
					let obj = {}
					for (let v of storeTypeData) {
						obj[v.code] = v.name
					}
					return obj
				}
				this.storeType = montage(storeTypeData)
			})
		},
		onSubmit () {
			if (sessionStorage.getItem('searchFlag')) {
				sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
				sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
				sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
				sessionStorage.setItem('userList', JSON.stringify(this.userList))
			}
			this.empty = false
			this.tableData = []
			order({
				page: this.queryInfo.pageNum - 1,
				size: this.queryInfo.pageSize,
				vo: Object.fromEntries(Object.entries(this.formInline).map(([key, value]) => [key, value === '' ? null : value]))
			}).then(res => {
				this.queryInfo.total = res.data.data.total
				this.tableData = res.data.data.content.map(a => {
					if (a.phone) {
						a.phone = this.$msg.filterBridal(a.phone)
					}
					return a
				})
			}).finally(res => {
				this.empty = true
			})
		},
		rowClassName ({ row, rowIndex }) {
			row.index = rowIndex
		},
		getOrderStatus (orderId) {
			this.$refs.orderDialogRef.show(orderId)
		},
		exportExcel () {
			const loading = this.$loading({
				lock: true,
				text: '正在导出表格，请稍后',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			})
			let param = JSON.parse(JSON.stringify(this.formInline))
			// if (!param.dateStart) {
			// 	param.dateStart =
			// 		this.$moment()
			// 			.subtract(1, 'months')
			// 			.format('YYYY-MM-DD') + ' 00:00:00'
			// 	param.dateEnd = this.$moment().format('YYYY-MM-DD') + ' 00:00:00'
			// }
			Object.keys(param).forEach(key => (param[key] === '' || param[key] === null) && delete param[key])
			orderExport(param).then(res => {
				let blob = res.data
				const fileReader = new FileReader()
				fileReader.readAsDataURL(blob)
				fileReader.onload = event => {
					let a = document.createElement('a')
					let _fileName = '订单查询' + '.xls'
					if (this.value2.length) {
						_fileName = '订单查询' + this.value2[0] + '-' + this.value2[1] + '.xls'
					}
					a.download = _fileName
					a.href = event.target.result
					document.body.appendChild(a)
					a.click()
					document.body.removeChild(a)
					loading.close()
				}
			})
		},
		handleSelect (item) {
			this.formInline.storeId = item.id
			this.basicsInfo.storeName = item.companyName
		},
		selectUserList (val) {
			if (val.trim()) {
				let systemCode = this.formInline.originType == 'BRIDAL' ? 'BRIDAL' : this.formInline.originType == 'VIDEO' ? 'VIDEO' : ''
				getAllUsersByUserName(val, systemCode).then(res => {
					if (res.data.success) {
						this.userList = res.data.data.map(a => {
							if (a.userName) {
								a.userName = this.$msg.filterBridal(a.userName)
							}
							return a
						})
					}
				})
			}
		},
		selectSalemanList (val) {
			if (val.trim()) {
				getSalesmanByFullName(val).then(res => {
					if (res.data.success) {
						this.salemanList = res.data.data
					}
				})
			}
		},
		filterMethod (val) {
			if (val.trim()) {
				storeQueryListByCode(val).then(res => {
					if (res.data.success) {
						this.storeListByCode = res.data.data
					}
				})
			}
		},
		filterByName (val) {
			if (val.trim()) {
				storeQueryListByName(val).then(res => {
					if (res.data.success) {
						this.storeListByCode = res.data.data
					}
				})
			}
		},
		// querySearchAsync(queryString, cb) {
		//   storeQueryListByCode(queryString).then(res => {
		//     res.data.data.forEach(item => {
		//       item.value = item.code
		//     });
		//     cb(res.data.data)
		//   })
		// },
		SelectStoreName (item) {
			this.formInline.storeId = item.id
			this.basicsInfo.storeCode = item.code
		},
		queryStoreNameAsync (queryString, cb) {
			storeQueryListByName(queryString).then(res => {
				res.data.data.forEach(item => {
					item.value = item.code
				})
				cb(res.data.data)
			})
		},
		selectFullName (item) {
			this.formInline.salesmanId = item.id
		},
		queryFullNameAsync (queryString, cb) {
			// 改成业务的模糊查询
			getSalesmanByFullName(queryString).then(res => {
				res.data.data.forEach(item => {
					item.value = item.fullName
				})
				cb(res.data.data)
			})
		},
		changePage (val) {
			this.queryInfo = val
			this.onSubmit()
		}
	}
}
</script>
<style scoped lang="less">
@import 'index';
@deep: ~'>>>';
</style>
